import React, { useState } from 'react';
import { FaCalendarAlt, FaUser, FaSearchPlus } from 'react-icons/fa';

const HotelReviewCard = ({ review }) => {
  const [zoomedImg, setZoomedImg] = useState(null);
  
  if (!review) return null;

  const customer = review.jjbooking?.jjcustomer;

  return (
    <>
      <div className="ven-rev-card">
        {/* Avatar + Name + Rating */}
        <div className="ven-rev-card-top">
          <div className="ven-rev-card-avatar">
            <FaUser />
          </div>
          <div className="ven-rev-card-meta">
            <strong>{customer?.cus_username || '—'}</strong>
            <small>{customer?.cus_email || '—'}</small>
            {/* Rating Stars - Like Testimonial */}
            <div className="ven-rev-card-rating">
              {[...Array(5)].map((_, i) => (
                <span key={i} className={i < review.rating ? "star-filled" : "star-empty"}>
                  ★
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Message - No quotes, no italics */}
        <p className="ven-rev-card-message">
          {review.review_message || 'No message provided.'}
        </p>

        {/* Image with thumbnail and zoom - Like Testimonial */}
        {review.image && (
          <div className="ven-rev-card-img-wrap">
            <div className="ven-rev-card-img-thumb-wrap">
              <img
                src={`http://127.0.0.1:8000/storage/${review.image}`}
                alt="Review"
                className="ven-rev-card-img-thumb"
                onClick={() => setZoomedImg(`http://127.0.0.1:8000/storage/${review.image}`)}
                onError={(e) => { e.target.parentElement.style.display = "none"; }}
              />
              <div
                className="ven-rev-card-img-overlay"
                onClick={() => setZoomedImg(`http://127.0.0.1:8000/storage/${review.image}`)}
              >
                <FaSearchPlus />
              </div>
            </div>
          </div>
        )}

        {/* Footer */}
        <div className="ven-rev-card-footer">
          <span className="ven-rev-card-date">
            <FaCalendarAlt />
            {review.created_at
              ? new Date(review.created_at).toLocaleDateString()
              : '—'}
          </span>
        </div>
      </div>

      {/* Zoom Modal - Like Testimonial */}
      {zoomedImg && (
        <div className="ven-rev-zoom-backdrop" onClick={() => setZoomedImg(null)}>
          <div className="ven-rev-zoom-box" onClick={(e) => e.stopPropagation()}>
            <button className="ven-rev-zoom-close" onClick={() => setZoomedImg(null)}>✕</button>
            <img src={zoomedImg} alt="Zoomed" className="ven-rev-zoom-img" />
          </div>
        </div>
      )}
    </>
  );
};

export default HotelReviewCard;